// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A9Tt6","content":"styles_content__26QXx"};